<!-- Affiché si le dossier est chargé -->
@if (folder$ | async; as folder) {
    <div class="container">
        @if (folderTabInfos.view.isArchive) {
            <app-archived-folder-detail class="content" [folder]="folder" [view]="folderTabInfos.view"></app-archived-folder-detail>
        } @else {
            <app-folder-detail class="content" [folder]="folder" [view]="folderTabInfos.view" [readonly]="folderTabInfos.readonly"></app-folder-detail>
        }

        <div class="reminder-notifications-container">
            @for (reminderNotification of reminderNotifications$ | async; track reminderNotification.id) {
                <app-reminder-notification
                    [title]="reminderNotification.title"
                    [text]="reminderNotification.text"
                    [creationDate]="reminderNotification.creationDate"
                    (closed)="onReminderNotificationClose(reminderNotification)"></app-reminder-notification>
            }
        </div>

        <ngx-spinner name="detail-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
    </div>
}
